<template>
    <div class="about-us">
      <div class="header-bottom">
        <div class="line-style">
          <span class="dot"></span>
          <span class="lines"></span>
        </div>
        <div class="font-size">
          <div class="text">在线下单</div>
          <div class="letter">Place an Order</div>
        </div>
        <div class="line-style">
          <span class="lines"></span>
          <span class="dot"></span>
        </div>
      </div>
      <div class="introduce-main">
       <div class="form-box">
        <div class="form-title">
            <span class="circle-text">起</span>
            <span>线路起点地址</span>
        </div>
        <div class="form-content">
            <div style="display: flex;align-items: flex-end;">
                <img src="@/assets/homepages/transport-icon.png" alt="" style="width: 18px;height: 18px;margin-right: 21px;cursor: pointer;" @click="handleToggle">
                <el-input v-model="startAddress" placeholder="请输入起点地址" style="width: 600px;"></el-input>
            </div>
            <div style="display: flex;flex-direction: column;margin-top: 54px;">
                <div class="circle-text" style="background-color: #F1BC3F;margin-bottom: 27px;">终</div>
                <el-input v-model="endAddress" placeholder="请输入终点地址" style="margin-left: 40px;width: 600px;"></el-input>
            </div>
        </div>
       </div>
       <div class="form-box">
        <div class="form-title">
            <img src="@/assets/homepages/car-icon.png" alt="" style="width: 18px;height: 18px;margin-right: 8px;">
            <span>广告信息</span>
        </div>
        <div class="gd-form-content">
            <el-form label-position="top">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item label="联系人">
                            <el-input v-model="name" placeholder="请输入联系人称呼"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="联系方式">
                            <el-input v-model="phone" type="number" placeholder="请输入联系方式"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="广告尺寸">
                            <div style="display: flex;align-items: center;">
                                <el-input v-model="gdlength" placeholder="长" type="number" style="width: 160px;">
                                    <span slot="suffix" style="color: #181818;margin-right: 12px;line-height: 45px;">米</span>
                                </el-input>
                                <div class="center-line"></div>
                                <el-input v-model="gdwidth" placeholder="宽" type="number" style="width: 160px;">
                                    <span slot="suffix" style="color: #181818;margin-right: 12px;line-height: 45px;">米</span>
                                </el-input>
                                <div class="center-line"></div>
                                <el-input v-model="gdhigh" placeholder="高" type="number" style="width: 160px;">
                                    <span slot="suffix" style="color: #181818;margin-right: 12px;line-height: 45px;">米</span>
                                </el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
       </div>
       <div style="width: 1041px;">
            <el-button @click="submit" class="submit-btn">立即下单</el-button>
            <div style="color: #7B7B7B;font-size: 16px;text-align: left;margin-top: 16px;">下单后我们会有专员联系您，请填写真实的联系方式</div>
        </div>
      </div>
      <el-dialog
        title="下单成功"
        :visible.sync="submitSuccess"
        custom-class="dialog-style"
        width="20%">
        <span>下单成功！我们的专员会处理您的广告需求，稍后会通过电话和您联系，请留意电话信息。</span>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" icon="el-icon-check" @click="submitSuccess = false" style="background-color: #9C6210;border-radius: 6px;height: 38px;border: none;">确 定</el-button>
        </span>
        </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        startAddress:'',
        endAddress:'',
        name:'',
        phone:'',
        gdlength:'',
        gdwidth:'',
        gdhigh:'',
        submitSuccess:false
      }
    },
    props: ['contentText'],
    methods: {
        handleToggle(){
            let copyStartAddress = JSON.parse(JSON.stringify(this.startAddress))
            let copyEndAddress = JSON.parse(JSON.stringify(this.endAddress))
            this.startAddress = copyEndAddress;
            this.endAddress = copyStartAddress;
        },
        submit(){
            if(this.startAddress && this.endAddress && this.name && this.phone && this.gdlength && this.gdwidth && this.gdhigh){
                this.submitSuccess = true;
            }else{
                this.$message({
                    message: '请先填写完整信息',
                    type: 'warning'
                });
            }
        }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .about-us {
    .header-bottom {
      width: 100%;
      height: 128px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
  
      .line-style {
        height: 10px;
        display: flex;
        align-items: center;
        span {
          display: inline-block;
          background: #4B3C27;
          opacity: 1;
        }
        .dot {
          width: 9px;
          height: 9px;
          border-radius: 50%;
        }
        .lines {
          width: 447px;
          height: 1px;
        }
      }
      .font-size {
        margin: 0 20px;
        .text,
        .letter {
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #4B3C27;
        }
        .text {
          font-size: 48px;
        }
        .letter {
          font-size: 24px;
        }
      }
    }
    .introduce-main {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    //   height: 650px;
        padding: 40px 0;
      background-color: #DDDDDD;
      .form-box {
        width: 1200px;
        box-shadow: 0px 0px 6px 1px rgba(0,0,0,0.08);
        border-radius: 8px;
        background-color: #ffffff;
        padding: 27px 25px;
        margin-bottom: 43px;
        .form-title {
            color: #181818;
            font-size: 24px;
            text-align: left;
            margin-bottom: 24px;
            display: flex;
            align-items: center;
        }
        .circle-text {
            width: 18px;
            height: 18px;
            display: inline-block;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            font-size: 12px;
            // padding: 4px;
            color: #ffffff;
            background-color: #EC892E;
            margin-right: 8px;
        }
        .form-content {
            ::v-deep .el-input__inner {
                border-radius: 16px;
                height: 48px;
            }
        }
        .gd-form-content {
            ::v-deep .el-input__inner {
                border-radius: 16px;
                height: 48px;
            }
            ::v-deep .el-form-item__label {
                width: 100%;
            }
        }
        .center-line {
            width: 16px;
            height: 2px;
            background-color: #DDDDDD;
            margin: 0 20px;
        }
      }
      .submit-btn {
        background-color: #9C6210;
        height: 48px;
        border-radius: 8px;
        color: #ffffff;
        width: 100%;
        font-size: 24px;
      }
    }
    .scope-of-services {
      background: #f5f5f5;
      // height: 223px;
      padding: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .server-title {
        width: 1192px;
        text-align: left;
        span {
          display: inline-block;
        }
        .text-title {
          font-size: 24px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 500;
          color: #f1bc3f;
        }
        .latter-title {
          margin-left: 10px;
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #acacac;
        }
      }
      .server-contetn {
        margin-top: 25px;
        width: 1192px;
        text-align: justify;
        font-size: 16px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #7b7b7b;
      }
    }
  }
  .dialog-style {
    ::v-deep .el-dialog__title {
        text-align: left;
        font-weight: bold;
    }
  }
  </style>